import { createStore, applyMiddleware, compose  } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension';

import rootReducer from './allReducers';
import Reactotron from 'ReactotronConfig'


const middleware = [thunk];
let composed = applyMiddleware(...middleware);
const createdEnhancer = Reactotron.createEnhancer();

// Esto deberia ser solo para dev
// if (process.env.NODE_ENV !== 'production') {
    middleware.push(createLogger());
    composed = compose(
      composeWithDevTools(applyMiddleware(...middleware)),
      createdEnhancer
    );
//   }

export const store = createStore(
    rootReducer, 
    composed
);


// export const store = createStore(
//     rootReducer, 
//     applyMiddleware(
//         thunk
//     )
// );